import React, { memo } from 'react';
import { Drawer, List, ListItem, ListItemText } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { FaYoutube } from 'react-icons/fa';
import { useTypedSelector } from 'hooks/useTypedSelector';
import { useActions } from 'hooks/useActions';
import './MainMenu.scss';

export const MainMenu = memo(({ onClose }: { onClose: () => void }) => {
  const [blurActive, setBlurActive] = React.useState(false);
  const { isAuthenticated } = useTypedSelector((state) => state.auth);
  const { logOutUser } = useActions();
  const navigate = useNavigate();

  const onLogOut = async () => {
    await logOutUser();
  };

  const handleEditProfile = () => {
    navigate('/profile');
  };

  React.useEffect(() => {
    const timer = setTimeout(() => setBlurActive(true), 10);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Drawer
      open={true}
      onClose={onClose}
      className={`mobile-sidebar ${blurActive ? 'blur-active' : ''}`}
    >
      <List>
        <ListItem>
          {!isAuthenticated ? (
            <ListItemText onClick={() => navigate('/users/login')} primary="Sign in" />
          ) : (
            <ListItemText onClick={onLogOut} primary="Log out" className="log-out-mob" />
          )}
        </ListItem>
        {isAuthenticated && (
          <ListItem>
            <ListItemText onClick={handleEditProfile} primary="Profile" />
          </ListItem>
        )}
        <ListItem>
          <ListItemText onClick={() => navigate('/edit')} primary="Add a place" />
        </ListItem>
        <ListItem>
          <ListItemText onClick={() => navigate('/about')} primary="About" />
        </ListItem>
        <ListItem style={{ gap: '20px' }}>
          <FaYoutube
            onClick={() => window.open('https://www.youtube.com/@tuksumsLV', '_blank')}
            style={{ color: '#fff' }}
            className="tiktok-icon"
          />
        </ListItem>
      </List>
    </Drawer>
  );
});
